var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export var getEmptyTalentReviewLabelAxisEdit = function () { return ({
    axisLabel: "",
    lowLabel: "",
    middleLabel: "",
    highLabel: "",
    lowDescription: "",
    middleDescription: "",
    highDescription: "",
}); };
export var getEmptyTalentReviewLabelBoxEdit = function () { return ({
    name: "",
    boxDescription: "",
}); };
var getEmptyTalentReviewLabelEdit = function () { return ({
    yAxis: getEmptyTalentReviewLabelAxisEdit(),
    xAxis: getEmptyTalentReviewLabelAxisEdit(),
    boxes: new Array(9).fill(getEmptyTalentReviewLabelBoxEdit()),
}); };
/* eslint-disable  @typescript-eslint/no-empty-function */
export var GlobalStateContext = React.createContext({
    getPageStates: function () { },
    /* eslint-disable @typescript-eslint/no-unused-vars */
    /* eslint-enable @typescript-eslint/no-unused-vars */
    /* eslint-disable @typescript-eslint/no-unused-vars */
    clearPageStates: function () { },
    /* eslint-enable @typescript-eslint/no-unused-vars */
    /* eslint-disable @typescript-eslint/no-unused-vars */
    updatePageStates: function (changes) { },
    /* eslint-enable @typescript-eslint/no-unused-vars */
    /* eslint-disable @typescript-eslint/no-unused-vars */
    setHoldUrl: function (url) { },
    /* eslint-enable @typescript-eslint/no-unused-vars */
    /* eslint-disable @typescript-eslint/no-unused-vars */
    getHoldUrl: function () { return undefined; },
    /* eslint-enable @typescript-eslint/no-unused-vars */
    /* eslint-disable @typescript-eslint/no-unused-vars */
    resetHoldUrl: function (navigate, override) { },
    /* eslint-enable @typescript-eslint/no-unused-vars */
    /* eslint-disable @typescript-eslint/no-unused-vars */
    clearTalentReviewLabelEdits: function () { return undefined; },
    setTalentReviewLabelEdits: function (arg) { return undefined; },
    getTalentReviewLabelEdits: function () { return getEmptyTalentReviewLabelEdit(); },
    setTalentReviewVersion: function (arg0) { return undefined; },
    talentReviewVersion: null,
    /* eslint-enable @typescript-eslint/no-unused-vars */
});
export var GlobalStateProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState({}), pageStates = _b[0], setPageStates = _b[1];
    var holdUrl = React.useRef();
    var _c = React.useState(null), talentReviewVersion = _c[0], setTalentReviewVersion = _c[1];
    var _d = React.useState(getEmptyTalentReviewLabelEdit()), talentReviewLabelEdits = _d[0], setTalentReviewLabelEdits = _d[1];
    var value = React.useMemo(function () {
        return {
            getPageStates: function () { return pageStates; },
            clearPageStates: function () {
                setPageStates({});
            },
            setHoldUrl: function (url) {
                holdUrl.current = url;
            },
            getHoldUrl: function () { return holdUrl.current; },
            resetHoldUrl: function (navigate, override) {
                holdUrl.current = undefined;
                setTimeout(function () {
                    var destination = new URL(override || window.location.pathname, window.location.origin);
                    var currentSearchParams = new URLSearchParams(window.location.search);
                    currentSearchParams.forEach(function (value, key) {
                        if (!destination.searchParams.has(key)) {
                            destination.searchParams.set(key, value);
                        }
                    });
                    if (!destination.hash) {
                        destination.hash = window.location.hash;
                    }
                    navigate("".concat(destination.pathname).concat(destination.search).concat(destination.hash));
                }, 0);
            },
            updatePageStates: function (changes) {
                setPageStates(function (previous) { return (__assign(__assign({}, previous), changes)); });
            },
            clearTalentReviewLabelEdits: function () {
                setTalentReviewLabelEdits(getEmptyTalentReviewLabelEdit());
            },
            setTalentReviewLabelEdits: setTalentReviewLabelEdits,
            getTalentReviewLabelEdits: function () { return talentReviewLabelEdits; },
            setTalentReviewVersion: setTalentReviewVersion,
            talentReviewVersion: talentReviewVersion,
        };
    }, [
        talentReviewVersion,
        pageStates,
        (holdUrl === null || holdUrl === void 0 ? void 0 : holdUrl.urls) || [],
        holdUrl === null || holdUrl === void 0 ? void 0 : holdUrl.onUrl,
        talentReviewLabelEdits,
    ]);
    return (_jsx(GlobalStateContext.Provider, __assign({ value: value }, { children: children })));
};
